import React from 'react';

class ItemTabBar extends React.Component {

    constructor(props) {
      super(props);
      this.indexToTab = {
        'subscribed':['timeline','details','client','tarifs','documents','emaillist'],
        'devis':['timeline','details','client','tarifs','emaillist'],
        'tarif':['timeline','details','tarifs'],
        'error':['comparateurs']
      }
    }

    selected() {
        return this.indexToTab[this.props.type].indexOf(this.props.tab)
    }

    classAtIndex(i) {
        return ( i==this.selected() )?' tab_item_selected':''
    }

    onClick(i) {
        if ( i != this.selected() ) {
            this.props.container.setTab(this.indexToTab[this.props.type][i]) 
        }
    }

    render() {
        let container = this.props.container
        switch ( this.props.type ) {
            case 'tarif':
                return <div className='tab_container'>
                    <div className={'tab_item'+this.classAtIndex(0)} onClick={container.openTimeline.bind(container)}>
                        Suivi
                    </div>
                    <div className={'tab_item'+this.classAtIndex(1)} onClick={container.openDetails.bind(container)}>
                        Détails
                    </div>
                    <div className={'tab_item'+this.classAtIndex(2)} onClick={container.openTarifs.bind(container)}>
                        Tarifs
                    </div>
                </div>
            case 'devis':
                    return <div className='tab_container'>
                    <div className={'tab_item'+this.classAtIndex(0)} onClick={container.openTimeline.bind(container)}>
                        Suivi
                    </div>
                    <div className={'tab_item'+this.classAtIndex(1)} onClick={container.openDetails.bind(container)}>
                        Détails
                    </div>
                    {this.props.showClient?<div className={'tab_item'+this.classAtIndex(2)} onClick={container.openClient.bind(container)}>
                        Formulaire souscription
                    </div>:''}
                    <div className={'tab_item'+this.classAtIndex(3)} onClick={container.openTarifs.bind(container)}>
                        Tarifs
                    </div>
                    <div className={'tab_item'+this.classAtIndex(4)} onClick={container.openEmailList.bind(container)}>
                        Autres devis
                    </div>
                </div>
            case 'subscribed':
                return <div className='tab_container'>
                <div className={'tab_item'+this.classAtIndex(0)} onClick={container.openTimeline.bind(container)}>
                    Suivi
                </div>
                <div className={'tab_item'+this.classAtIndex(1)} onClick={container.openDetails.bind(container)}>
                    Détails
                </div>
                {this.props.showClient?<div className={'tab_item'+this.classAtIndex(2)} onClick={container.openClient.bind(container)}>
                    Formulaire souscription
                </div>:''}
                <div className={'tab_item'+this.classAtIndex(3)} onClick={container.openTarifs.bind(container)}>
                    Tarifs
                </div>
                <div className={'tab_item'+this.classAtIndex(4)} onClick={container.openDocuments.bind(container)}>
                    Documents
                </div>
                <div className={'tab_item'+this.classAtIndex(5)} onClick={container.openEmailList.bind(container)}>
                    Autres devis
                </div>
            </div>
            case 'error':
                return <div className='tab_container'>
                    <div className={'tab_item'+this.classAtIndex(0)} onClick={container.openComparateurs.bind(container)}>
                        Données comparateurs
                    </div>
                </div>
        }
    }
}

export default ItemTabBar;